import { Typography, Box, List, ListItem, ListItemText } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';

const LetzteTrainingsCard = ({ trainings, ansicht, nutzer, navigate }) => {
    if (!(trainings?.length > 0)) {
        return (
            <Typography color="#93c5fd" align="center" variant="caption" sx={{ py: 2 }}>
                Noch keine Trainings vorhanden
            </Typography>
        );
    }

    return (
        <>
            <List dense sx={{ overflow: 'auto', flex: 1, width: '100%' }}>
                {trainings.slice(0, 3).map((training) =>
                    training && training.id ? (
                        <ListItem
                            key={training.id}
                            sx={{
                                px: 0,
                                py: 0.5,
                                width: '100%',
                                flex: '0 0 auto',
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    p: 1,
                                    border: '1px solid rgba(59, 130, 246, 0.3)',
                                    borderRadius: '16px',
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Box>
                                                <Typography variant="body2" fontWeight={600} color="#fff">
                                                    {training.trainingsplan_name || 'Unbekannt'}
                                                </Typography>
                                                {ansicht === 'gruppe' && (
                                                    <Typography variant="caption" color="#93c5fd">
                                                        {training.vname || ''} {training.nname || ''}
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    }
                                    secondary={
                                        <Typography variant="caption" color="#93c5fd">
                                            {training.datum
                                                ? new Date(training.datum).toLocaleDateString('de-DE', {
                                                    weekday: 'short',
                                                    day: '2-digit',
                                                    month: 'short',
                                                })
                                                : 'Kein Datum'}
                                        </Typography>
                                    }
                                />
                                <LaunchIcon
                                    onClick={() => navigate(`/trainingdetails/${training.id}`)}
                                    sx={{ cursor: 'pointer', color: '#3b82f6' }}
                                />
                            </Box>
                        </ListItem>
                    ) : null
                )}
            </List>
            <ListItem
                sx={{
                    px: 0,
                    py: 0.5,
                    width: '100%',
                    flex: '0 0 auto',
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        p: 1,
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        borderRadius: '16px',
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    <ListItemText>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography
                                variant="body2" fontWeight={600} color="#fff"
                            >
                                Historie
                            </Typography>
                            <LaunchIcon
                                onClick={() => navigate(`/historie/${nutzer.id}`)}
                                sx={{ cursor: 'pointer', color: '#3b82f6' }}
                            />
                        </Box>
                    </ListItemText>
                </Box>
            </ListItem>
        </>
    );
};

export default LetzteTrainingsCard;
